import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HeroSection } from './components/HeroSection';
import { InvestorDashboard } from './components/InvestorDashboard';
import { FoundHerExperience } from './components/FoundHerExperience';
import { Footer } from './components/Footer';
export type ViewState = 'hero' | 'investor' | 'foundher';
export function App() {
  const [view, setView] = useState<ViewState>('hero');
  return <div className="min-h-screen bg-momentum text-white font-inter overflow-x-hidden selection:bg-accent-purple/30" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {view === 'hero' && <motion.div key="hero" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0,
        y: -20
      }} className="min-h-screen flex flex-col" data-id="element-2">
            <div className="flex-1" data-id="element-3">
              <HeroSection onNavigate={setView} data-id="element-4" />
            </div>
            <Footer data-id="element-5" />
          </motion.div>}

        {view === 'investor' && <motion.div key="investor" initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -20
      }} className="min-h-screen flex flex-col" data-id="element-6">
            <div className="flex-1" data-id="element-7">
              <InvestorDashboard onNavigate={() => setView('hero')} data-id="element-8" />
            </div>
            <Footer data-id="element-9" />
          </motion.div>}

        {view === 'foundher' && <motion.div key="foundher" initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -20
      }} className="min-h-screen flex flex-col" data-id="element-10">
            <div className="flex-1" data-id="element-11">
              <FoundHerExperience onNavigate={() => setView('hero')} data-id="element-12" />
            </div>
            <Footer data-id="element-13" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}